import { formatCalendarRange } from '@/helpers/dateHelper';
import { useLeaveTypeCalendarDisplay } from '@/pages/team/teamMember/calendar/useLeaveTypeCalendarDisplay';
import {
  UNKNOWN_LEAVE_TYPE_SURFACE_COLOR,
  UNKNOWN_LEAVE_TYPE_WRAPPER_COLOR
} from '@/services/availability/availability.types';
import { PendingAvailabilityException } from '@/services/gql/graphql.generated';
import { strings } from '@/services/translation/strings';
import { FunctionComponent } from 'react';
import { twMerge } from 'tailwind-merge';
import { cellBase } from './calendarCellStyles';

interface MyCalendarPendingExceptionCellProps {
  exception: PendingAvailabilityException;
}
const MyCalendarPendingExceptionCell: FunctionComponent<MyCalendarPendingExceptionCellProps> = ({ exception }) => {
  const { label, hasLeaveType, colour } = useLeaveTypeCalendarDisplay(exception.leaveType?.id);
  const requestedText = hasLeaveType
    ? `${strings.common.requested.toUpperCase()}: ${label}`
    : formatCalendarRange(strings.common.requested.toUpperCase(), exception.start!, exception.end!);
  const wrapperColor = hasLeaveType ? (colour ? `${colour}80` : UNKNOWN_LEAVE_TYPE_WRAPPER_COLOR) : undefined;
  const surfaceColor = hasLeaveType ? (colour ?? UNKNOWN_LEAVE_TYPE_SURFACE_COLOR) : undefined;
  return (
    <div
      className="h-full flex flex-col space-y-1 py-2 justify-center items-center px-5"
      style={wrapperColor ? { backgroundColor: wrapperColor } : undefined}
    >
      <div className="flex flex-row items-stretch space-x-2 w-full">
        <div
          className={twMerge(cellBase, hasLeaveType ? 'py-4 px-8' : 'border border-dotted border-gray-500 bg-gray-200')}
          style={surfaceColor ? { backgroundColor: surfaceColor } : undefined}
        >
          <div className="flex flex-row justify-between items-center px-5">
            <p className={twMerge('font-semibold', hasLeaveType && !colour && 'text-gray-700')}>{requestedText}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MyCalendarPendingExceptionCell;
